import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ImgWH } from '@pages/CommonStyle/common.style';

export const NumberCardLayout = styled.div<{ img: string }>`
  padding: 96px 0;

  display: flex;
  flex-direction: column;

  background-image: url(${(props) => props.img});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 64px 0;
  }
`;

export const DividerVertical = styled.div`
  width: 1px;
  height: 60px;
  background-color: #ffffff33;
  margin: auto 32px; /* 좌우 32px 여백 */

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    width: 1px;
    height: 16px;

    margin: 16px auto;
  }
`;

export const NumberCardTextLayout = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: row;
  width: 100%;

  justify-content: center;
  gap: ${({ gap }) => (gap ? `${gap}px;` : '0px;')} ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    flex-direction: column;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
  }
`;
